import React, { useState, useEffect } from 'react';

const HeroBanner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: 'https://customer-assets.emergentagent.com/job_homepage-redesign-26/artifacts/hoynpfdi_Screenshot%202026-04-08%20at%208.47.40%E2%80%AFpm.png',
      title: 'Guwahati Asian Film Festival',
      subtitle: 'A Home for New Cinema from the East'
    },
    {
      id: 2,
      image: 'https://customer-assets.emergentagent.com/job_homepage-redesign-26/artifacts/0muen243_IMG_5588.jpg',
      title: 'Beyond Borders. Beyond Screens.',
      subtitle: 'Breaking Barriers, One Frame at a Time'
    },
    {
      id: 3,
      image: 'https://customer-assets.emergentagent.com/job_homepage-redesign-26/artifacts/qebf6s56_GAFF2025.png',
      title: "Framing Tomorrow's Storyteller",
      subtitle: 'From New Voices to Lasting Stories'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <section id="banner" className="relative h-screen w-full overflow-hidden pt-20">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          {/* Background Image */}
          <div className="absolute inset-0">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover"
            />
            {/* Dark Overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-transparent" />
          </div>

          {/* Content */}
          <div className="relative h-full container mx-auto px-4 sm:px-6 flex items-center">
            <div className="max-w-4xl text-left" style={{ animation: index === currentSlide ? 'slideInLeft 1s ease-out' : 'none' }}>
              {/* Logo */}
              <div className="mb-4 sm:mb-6 md:mb-8">
                <img 
                  src="https://customer-assets.emergentagent.com/job_homepage-redesign-26/artifacts/yvkqg1i6_2%20copy.png"
                  alt="GAFF Logo"
                  className="h-32 sm:h-44 md:h-56 lg:h-64 xl:h-72 w-auto"
                />
              </div>
              
              {/* Festival Dates Badge */}
              <div className="inline-block mb-4 sm:mb-6 md:mb-8 border-2 border-red-500 bg-red-500/10 px-3 sm:px-4 py-2 rounded-lg">
                <p className="text-xs sm:text-sm font-bold uppercase tracking-widest text-red-400">
                  11-14 February, 2027
                </p>
              </div>

              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold mb-4 sm:mb-5 md:mb-6 leading-tight">
                {slide.title}
              </h1>
              <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-gray-300 max-w-2xl leading-relaxed">
                {slide.subtitle}
              </p>
            </div>
          </div>
        </div>
      ))}

      {/* Dots Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex gap-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`transition-all duration-300 ${
              index === currentSlide
                ? 'w-12 h-2 bg-red-500'
                : 'w-2 h-2 bg-white/40 hover:bg-white/60'
            } rounded-full`}
          />
        ))}
      </div>

      <style>{`
        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
      `}</style>
    </section>
  );
};

export default HeroBanner;
